import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Alert, Button, message, Space, Spin } from 'antd';
import dayjs from 'dayjs';
import {
  copyWinningBidToContract,
  createBehalfBidProposal,
  downloadFile,
  requestProposalAgain,
  sendBidResultMessage,
} from '../../api/constlink';
import BidderDetailComponent from '../../components/bidders/BidderDetailComponent';
import { RootState } from '../../modules';
import {
  Bidder,
  BidderParams,
  BidderStatus,
  getBidderDetailAsync,
  updateBidderAsync,
} from '../../modules/bidders';
import {
  getBidProposalFileAPIPath,
  initializeUploadProps,
} from '../../util/utils';
import moment from 'moment';
import { getBidPackageDetailAsync } from '../../modules/bid-packages';
import RequestProposalAgainModal from '../../components/bidders/RequestProposalAgainModal';
import SendBidResultMessageModal from '../../components/bidders/SendBidResultMessageModal';
import BidProposalCreateModal from '../../components/bid-chances/BidProposalCreateModal';

interface BidderDetailContainerProps {
  enterpriseId: string;
  projectId: string;
  bidPackageId: string;
  bidderId: string;
}
function BidderDetailContainer({
  match,
  history,
}: RouteComponentProps<BidderDetailContainerProps>) {
  const { enterpriseId, projectId, bidPackageId, bidderId } = match.params;
  const [visible, setVisible] = useState(false);
  const [visible1, setVisible1] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [alertMsg, setAlertMsg] = useState<any>();
  const [uploadProps, setUploadProps] = useState<any>();

  const { data, loading, error } = useSelector(
    (state: RootState) => state.bidders.bidder,
  );
  const bidPackage = useSelector(
    (state: RootState) => state.bidPackages.bidPackage.data,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (bidPackage === null) {
      dispatch(
        getBidPackageDetailAsync.request({
          enterpriseId,
          projectId,
          bidPackageId,
        }),
      );
    }
    dispatch(
      getBidderDetailAsync.request({
        enterpriseId,
        projectId,
        bidPackageId,
        bidderId,
      }),
    );
  }, [dispatch, bidPackage, enterpriseId, projectId, bidPackageId, bidderId]);

  useEffect(() => {
    (async () => {
      setUploadProps(
        await initializeUploadProps(
          getBidProposalFileAPIPath('' + data?.bidChance?.id),
        ),
      );
    })();
  }, [data?.bidChance?.id]);

  // useEffect(() => {
  //   if (data && data.status === BidderStatus.SUBMITTED) {
  //     setAlertMsg({
  //       message: '낙찰 업체 선정 전 품의를 받아야 합니다.',
  //       type: 'warning',
  //     });
  //   }
  // }, [data]);

  const updateBidderStatus = (status: BidderStatus) => {
    // setVisible(true);
    if (dayjs(bidPackage?.bidDueDateTime).isAfter(new Date())) {
      message.error('견적마감일 이후에 업체선정할 수 있습니다.');
      return;
    }

    dispatch(
      updateBidderAsync.request({
        enterpriseId,
        projectId,
        bidPackageId,
        bidder: {
          id: +bidderId,
          status,
        } as Bidder,
      }),
    );
  };

  const moveToBidProposalDetailPage = (bidProposalId: number) => {
    history.push(`${bidderId}/bidProposals/${bidProposalId}/detail`);
  };

  const createSubcontract = (bidder: Bidder) => {
    if (bidPackage === null) return;

    (async () => {
      const createContractDto: any = {
        title: bidPackage.name + ' 하도급 계약',
        gongjong: bidPackage.name,
        startDate: bidPackage.startDate,
        endDate: bidPackage.endDate,
        contractDate: moment().format('YYYY-MM-DD'),
        status: '0',
        // type1: bidPackage.type1,
        // type2: bidPackage.type2,
        description: '하도급 입찰에서 복사해 옴',
        contractCompany: {
          value: bidder.vendor.id,
        },
        advancedFeeRate: 10,
        invoiceContactUsers: bidder.users.map((user) => {
          return user.id;
        }),
        sovTotal:
          bidder.bidChance?.bidProposals[
            bidder.bidChance?.bidProposals.length - 1
          ].amount,
      };

      const lastBidProposalId =
        bidder.bidChance?.bidProposals[
          bidder.bidChance?.bidProposals.length - 1
        ].id;

      const params: BidderParams = {
        enterpriseId,
        projectId,
        bidPackageId,
        bidderId,
        createContractDto,
        lastBidProposalId,
      };
      const contract = await copyWinningBidToContract(params);
      if ('error' in contract) {
        setAlertMsg({
          message: '이미 하도급 계약을 생성 하셨습니다.',
          type: 'error',
        });
        return;
      }
      history.push(
        `/enterprises/${enterpriseId}/projects/${projectId}/subContracts/${contract.id}?tab=1`,
      );
    })();
  };

  const _downloadFile = async (attachFileId: string, fileName: string) => {
    await downloadFile(
      getBidProposalFileAPIPath(data!.bidChance!.id + ''),
      attachFileId,
      fileName,
    );
  };

  const _reconfirmBidChance = () => {
    setVisible1(true);
  };

  const onAlertClose = () => {
    setAlertMsg(null);
  };

  const moveToBidProposalBehalfCreatePage = () => {
    history.push(`${bidderId}/bidProposals?bidChanceId=${data?.bidChance?.id}`);
  };

  const _onCancelRequestProposalAgain = () => {
    setVisible1(false);
  };

  const _requestProposalAgain = async (formData: any) => {
    await requestProposalAgain({
      enterpriseId,
      projectId,
      bidPackageId,
      bidderId,
      reason: formData.reason,
    });
    dispatch(
      getBidderDetailAsync.request({
        enterpriseId,
        projectId,
        bidPackageId,
        bidderId,
      }),
    );
    setVisible1(false);
  };

  const openSendMessageModal = () => {
    setVisible(true);
  };

  const onCancel = () => {
    setVisible(false);
  };

  const _sendBidResultMessage = async () => {
    await sendBidResultMessage({
      enterpriseId,
      projectId,
      bidPackageId,
      bidderId,
      data: {},
    });
    setVisible(false);
    message.success('선정결과 알림 메시지를 정상적으로 발송하였습니다.');
  };

  const submitBidProposal = async (_data: any) => {
    const bidProposalParams: any = {
      enterpriseId,
      projectId,
      bidPackageId,
      bidderId,
      bidProposal: {
        ..._data,
        bidProposalLineItems: [],
      },
    };
    if (bidProposalParams.bidProposal?.file) {
      for (const _file of bidProposalParams.bidProposal.file) {
        if ('response' in _file) {
          _file.path = _file.response.path;
          _file.mimeType = _file.response.mimeType;
        }
      }
    }

    try {
      await createBehalfBidProposal(bidProposalParams);
      dispatch(
        getBidderDetailAsync.request({
          enterpriseId,
          projectId,
          bidPackageId,
          bidderId,
        }),
      );
      message.success('견적가 대신제출 성공');
    } catch (error: any) {
      message.error('견적가 대신제출 실패');
    }
    setVisible2(false);
  };

  const openBidProposalCreateModal = () => setVisible2(true);

  const closeBidProposalCreateModal = () => setVisible2(false);

  return (
    <>
      {loading && <Spin />}
      {error && <p style={{ textAlign: 'center' }}>에러 발생!</p>}
      {alertMsg && (
        <Alert
          message={`${alertMsg.message}`}
          type={
            alertMsg.type === 'error'
              ? 'error'
              : alertMsg.type === 'warning'
              ? 'warning'
              : 'info'
          }
          closable
          onClose={onAlertClose}
          style={{ marginTop: '5px', marginBottom: '5px' }}
          action={
            data &&
            data.status === BidderStatus.SUBMITTED && (
              <Space>
                <Button
                  size="small"
                  type="ghost"
                  onClick={() =>
                    history.push(`/enterprises/${enterpriseId}/approvals`)
                  }
                >
                  전자결재 요청하기
                </Button>
              </Space>
            )
          }
        />
      )}
      {data && bidPackage && (
        <BidderDetailComponent
          bidder={data}
          bidPackage={bidPackage}
          updateBidderStatus={updateBidderStatus}
          moveToBidProposalDetailPage={moveToBidProposalDetailPage}
          createSubcontract={createSubcontract}
          downloadFile={_downloadFile}
          reconfirmBidChance={_reconfirmBidChance}
          moveToBidProposalBehalfCreatePage={moveToBidProposalBehalfCreatePage}
          openSendMessageModal={openSendMessageModal}
          openBidProposalCreateModal={openBidProposalCreateModal}
        />
      )}
      {visible && (
        <SendBidResultMessageModal
          visible={visible}
          onCancel={onCancel}
          sendBidResultMessage={_sendBidResultMessage}
        />
      )}

      {visible1 && (
        <RequestProposalAgainModal
          visible1={visible1}
          onCancelRrequestProposalAgain={_onCancelRequestProposalAgain}
          requestProposalAgain={_requestProposalAgain}
        />
      )}

      {visible2 && (
        <BidProposalCreateModal
          visible={visible2}
          uploadProps={uploadProps}
          onFinish={submitBidProposal}
          onCancel={closeBidProposalCreateModal}
        />
      )}
    </>
  );
}

export default BidderDetailContainer;
